<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import CheckboxInput from "../Inputs/Checkbox.svelte";
  import Button from "../Button.svelte";
  import * as UserApi from "../../lib/apiLoader/user";
  import { NavigationType } from "../../lib/stores/session";
  import { navigateTo } from "../../lib/routing";
  import CustomHtml from "../CustomHTML.svelte";
  import Youtube from "../Youtube.svelte";

  export let currentRoute;
  let confirmed: boolean | undefined = undefined;
  let isLoading = false;

  const onClick = async () => {
    isLoading = true;
    await UserApi.saveUserSettings({ remind: confirmed });
    isLoading = false;
    navigateTo(NavigationType.Next);
  };

  $: copy = $getCopy("remind") as Record<string, string>;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
    <div class="flex flex-col mt-6 w-full items-start">
      <CheckboxInput
        class="w-24 lg:w-full"
        label={copy.yesCopy}
        onChange={() => (confirmed = true)}
        value={confirmed} />
      <CheckboxInput
        class="w-24 lg:w-full"
        label={copy.noCopy}
        onChange={() => (confirmed = false)}
        value={confirmed == undefined ? undefined : !confirmed} />
    </div>
    <Button class="my-6 lg:max-w-32" primary disabled={confirmed === undefined} isBusy={isLoading} on:click={onClick}>
      {copy.buttonCopy}
    </Button>
    {#if copy.showLegalDisclaimer}
      <Typography
        desktop={TypographyType.Body1Medium}
        mobile={TypographyType.Body1Medium}
        copy={copy.customLegalDisclaimerCopy}
        --font-color="var(--color-grayscale-70)" />
    {/if}
    <CustomHtml customHtml={copy.customHtml} />
    <Youtube videoId={copy.videoId} />
  </svelte:fragment>
</BaseStep>
